// libs
import React from 'react';
import { styled } from '@nykaa/ui-components';

// constants
import { TAB_INDEX } from 'shared/constants';
import { DEFAULT_STORE } from 'shared/helpers/storeUrl';

interface StoreToggleProps {
  currentStoreId: string;
  option1StoreId: string;
  option2StoreId: string;
  toggleImage1: string;
  toggleImage2: string;
  option1AriaLabel: string;
  option2AriaLabel: string;
}

const TOGGLE_WIDTH = 118;
const TOGGLE_HEIGHT = 48;

const ToggleImage = styled.img`
  cursor: pointer;
  width: ${TOGGLE_WIDTH}px;
  height: ${TOGGLE_HEIGHT}px;
  flex-shrink: 0;
  display: block;
  object-fit: contain;
  transition: opacity 0.2s ease;
  margin-left: ${({ theme }) => theme.spacing.spacing80};
  &:hover {
    opacity: 0.85;
  }
`;

function StoreToggle({
  currentStoreId,
  option1StoreId,
  option2StoreId,
  toggleImage1,
  toggleImage2,
  option1AriaLabel,
  option2AriaLabel,
}: StoreToggleProps) {
  const handleToggleClick = () => {
    const targetStoreId = currentStoreId === option1StoreId ? option2StoreId : option1StoreId;
    const redirectUrl = targetStoreId === DEFAULT_STORE ? '/' : `/${targetStoreId}`;

    // Set flag in sessionStorage to indicate store was switched
    sessionStorage.setItem('store_switched_via_toggle', targetStoreId);
    sessionStorage.setItem('store_toggle_source', 'header_toggle');

    window.location.href = redirectUrl;
  };

  const currentImage = currentStoreId === option1StoreId ? toggleImage1 : toggleImage2;
  const currentAriaLabel = currentStoreId === option1StoreId ? option1AriaLabel : option2AriaLabel;

  return (
    <ToggleImage
      src={currentImage}
      alt={currentAriaLabel}
      aria-label={currentAriaLabel}
      width={TOGGLE_WIDTH}
      height={TOGGLE_HEIGHT}
      onClick={handleToggleClick}
      role="button"
      tabIndex={TAB_INDEX.ACTION_INVISIBILITY}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggleClick();
        }
      }}
    />
  );
}

export default StoreToggle;
